document.addEventListener("DOMContentLoaded", (e) => {
	const locationForm = document.querySelector(".location-ctn__form");
	if (locationForm) {
		locationForm.addEventListener("submit", function (e) {
			e.preventDefault();

			const regionSelect = locationForm.querySelector(".region-selector");
			if (!regionSelect) return;

			const selectedOption = regionSelect.options[regionSelect.selectedIndex];

			let theSlug = "";
			if (selectedOption && selectedOption.dataset && selectedOption.dataset.slug) {
				theSlug = selectedOption.dataset.slug;
				const url = physioclinicsVars.archive_url.replace(/\/$/, "") + "/" + encodeURIComponent(theSlug);
				window.location.href = url;
			}
		});
	}
});
